/* VBYC – Kachel-Freisteller (v14). Nur die Vorschaukacheln: weißer Fotohintergrund wird durch die Kachelfarbe ersetzt,
   das Teil bleibt so gelegt, wie es fotografiert wurde (Drehung nur per Produkt-Tag), wird mittig gesetzt und bekommt Schatten an der Kontur.
   Weiße Reste (z. B. am Hosensaum) werden entfernt. Belichtung: grelle Neonfarben und Überbelichtung werden gedämpft,
   dunkle Teile bekommen tieferes Schwarz. Alle Kacheln sind quadratisch und gleich groß. Originalfotos und Produktseite bleiben unverändert.
   Schnell: sichtbare Kacheln zuerst, Berechnung in Hintergrund-Threads, kleinere Fotos, fertige Kacheln werden im Browser gespeichert
   (beim nächsten Besuch und auf jeder weiteren Seite sofort da). */
(function () {
  if (window.__vbycTiles) return;
  window.__vbycTiles = true;

  var SELECTOR = '.vbyc-grid-square .product-card__media-link, .featured-products__slide .product-card__media-link';
  var VERSION = 'v14';
  var SIZE = 720;        /* Kantenlänge der fertigen Kachel in Pixeln */
  var MAX_SOURCE = 900;  /* größte Seite des Arbeitsbilds */
  var MIN_WIDTH = 720;   /* kleinste Fotobreite, die noch scharf genug ist */
  var FIT_NORMAL = 0.9;  /* Jacken, Pullover, Shirts: Anteil der Kachelgröße */
  var FIT_TALL = 0.92;   /* Hosen: Anteil der Kachelhöhe */
  var TALL_RATIO = 1.6;
  var MAX_UPSCALE = 4;   /* kleine Teile im Foto duerfen bis zu so stark vergroessert werden */
  var JPEG_QUALITY = 0.9;
  var MAX_LOADS = 6;     /* gleichzeitige Foto-Downloads */
  var GIVE_UP_MS = 12000;
  /* white: ab diesem Wert (0-255) gilt ein Pixel als weißer Hintergrund
     islandMax: größte weiße Insel (Anteil am Bild), die als Rest entfernt wird (z. B. Saum, Kordelstopper)
     sat/contrast: Grundfarbe; neon: wie stark grelle Farben entsättigt werden; neonDark: wie stark sie abgedunkelt werden
     dark: Stärke der Schwarz-Korrektur (0 = aus); highlight: ab diesem Helligkeitswert werden helle Stellen gedämpft */
  var CFG = { white: 242, holeMin: 0.012, edgeWhiteMin: 0.6, islandMax: 0.02, sat: 1.24, contrast: 1.1, neon: 0.28, neonDark: 0.1, dark: 0.5, highlight: 236 };

  var tile = '#A9C2B0';
  var db = null;
  var workers = [];
  var ready = [];        /* geladene Fotos, warten auf die Berechnung */
  var inlineBusy = false;
  var loadQueue = [];
  var activeLoads = 0;

  /* ======================================================================
     Analyse (läuft im Hintergrund-Thread, darf nichts außerhalb benutzen):
     Hintergrund entfernen, Kontur glätten, Belichtung angleichen, Umrissbox bestimmen.
     ====================================================================== */
  /*ANALYZE-START*/
  function analyze(px, w, h, cfg) {
    var n = w * h;
    var i, x, y, p, o, c, j;

    function ss(v, a, b) {
      var t = (v - a) / (b - a);
      t = t < 0 ? 0 : (t > 1 ? 1 : t);
      return t * t * (3 - 2 * t);
    }

    var white = new Uint8Array(n);
    for (i = 0; i < n; i++) {
      o = i * 4;
      if (px[o] >= cfg.white && px[o + 1] >= cfg.white && px[o + 2] >= cfg.white) white[i] = 1;
    }

    var edge = 0;
    var edgeWhite = 0;
    for (x = 0; x < w; x++) { edge += 2; edgeWhite += white[x] + white[(h - 1) * w + x]; }
    for (y = 0; y < h; y++) { edge += 2; edgeWhite += white[y * w] + white[y * w + w - 1]; }
    if (edgeWhite / edge < cfg.edgeWhiteMin) return null;

    var bg = new Uint8Array(n);
    var stack = new Int32Array(n);
    var sp = 0;
    var bgCount = 0;
    function seed(q) {
      if (white[q] && !bg[q]) { bg[q] = 1; bgCount++; stack[sp++] = q; }
    }
    function flood() {
      while (sp > 0) {
        p = stack[--sp];
        var px0 = p % w;
        var py0 = (p - px0) / w;
        if (px0 > 0) seed(p - 1);
        if (px0 < w - 1) seed(p + 1);
        if (py0 > 0) seed(p - w);
        if (py0 < h - 1) seed(p + w);
      }
    }
    for (x = 0; x < w; x++) { seed(x); seed((h - 1) * w + x); }
    for (y = 0; y < h; y++) { seed(y * w); seed(y * w + w - 1); }
    flood();

    /* Eingeschlossene weiße Flächen (z. B. zwischen den Beinen einer Hose) ebenfalls entfernen, wenn sie groß sind */
    var seen = new Uint8Array(n);
    var comp = new Int32Array(n);
    var mk = new Uint8Array(n);
    var org = new Int32Array(n);
    /* Kleine weisse Inseln, die nur von einer duennen dunklen Linie umgeben sind, die nahe am Hintergrund liegt
       (z. B. weisse Kordelstopper oder Reste am Saum): Insel samt Linie entfernen. Gibt die Anzahl der Linien-Pixel zurueck, sonst 0. */
    var needDark = false;
    function okWall(q) {
      if (white[q] || bg[q] || mk[q]) return false;
      if (!needDark) return true;
      var oq = q * 4;
      return px[oq] + px[oq + 1] + px[oq + 2] < 270 || touchesBg(q); /* tiefer in die Wand hinein nur dunkle Pixel (Kordel), kein helles Material */
    }
    function addNb(pp, og) {
      var ax = pp % w, q;
      if (ax > 0) { q = pp - 1; if (okWall(q)) { org[q] = og < 0 ? sp : og; mk[q] = 2; stack[sp++] = q; } }
      if (ax < w - 1) { q = pp + 1; if (okWall(q)) { org[q] = og < 0 ? sp : og; mk[q] = 2; stack[sp++] = q; } }
      if (pp >= w) { q = pp - w; if (okWall(q)) { org[q] = og < 0 ? sp : og; mk[q] = 2; stack[sp++] = q; } }
      if (pp < n - w) { q = pp + w; if (okWall(q)) { org[q] = og < 0 ? sp : og; mk[q] = 2; stack[sp++] = q; } }
    }
    function touchesBg(pp) {
      var ax = pp % w;
      return (ax > 0 && bg[pp - 1]) || (ax < w - 1 && bg[pp + 1]) || (pp >= w && bg[pp - w]) || (pp < n - w && bg[pp + w]);
    }
    /* Eine Insel gilt als Rest, wenn mindestens ein Viertel ihres Rands ueber eine duenne Wand (bis WALL Pixel, z. B. Kordel) an den Hintergrund grenzt */
    function wrapped(arr, count) {
      var WALL = 16;
      var k, qh = 0, ring, hit, hitN = 0, depth, levelEnd, end3 = 0;
      sp = 0;
      for (k = 0; k < count; k++) mk[arr[k]] = 1;
      for (k = 0; k < count; k++) addNb(arr[k], -1);
      ring = sp;
      hit = new Uint8Array(ring + 1);
      levelEnd = sp;
      needDark = false;
      for (depth = 1; depth <= WALL && qh < sp; depth++) {
        needDark = depth >= 8;
        for (; qh < levelEnd; qh++) {
          var cq = stack[qh];
          if (!hit[org[cq]] && touchesBg(cq)) { hit[org[cq]] = 1; hitN++; }
          if (depth < WALL) addNb(cq, org[cq]);
        }
        levelEnd = sp;
        if (depth === 3) end3 = levelEnd;
      }
      needDark = false;
      var ok = ring > 0 && hitN / ring >= 0.25;
      if (!end3) end3 = sp;
      var total = sp;
      for (k = 0; k < total; k++) {
        var vp = stack[k];
        if (ok && k < end3) { bg[vp] = 1; bgCount++; }
        mk[vp] = 0;
      }
      for (k = 0; k < count; k++) mk[arr[k]] = 0;
      sp = 0;
      return ok ? count : 0;
    }
    for (i = 0; i < n; i++) {
      if (!white[i] || bg[i] || seen[i]) continue;
      var cs = 0;
      var cp = 0;
      var bx0 = w, bx1 = 0, by0 = h, by1 = 0;
      comp[cs++] = i;
      seen[i] = 1;
      while (cp < cs) {
        p = comp[cp++];
        var qx = p % w;
        var qy = (p - qx) / w;
        var nb;
        if (qx < bx0) bx0 = qx;
        if (qx > bx1) bx1 = qx;
        if (qy < by0) by0 = qy;
        if (qy > by1) by1 = qy;
        if (qx > 0) { nb = p - 1; if (white[nb] && !bg[nb] && !seen[nb]) { seen[nb] = 1; comp[cs++] = nb; } }
        if (qx < w - 1) { nb = p + 1; if (white[nb] && !bg[nb] && !seen[nb]) { seen[nb] = 1; comp[cs++] = nb; } }
        if (qy > 0) { nb = p - w; if (white[nb] && !bg[nb] && !seen[nb]) { seen[nb] = 1; comp[cs++] = nb; } }
        if (qy < h - 1) { nb = p + w; if (white[nb] && !bg[nb] && !seen[nb]) { seen[nb] = 1; comp[cs++] = nb; } }
      }
      if (cs >= n * cfg.holeMin) {
        for (var t = 0; t < cs; t++) { bg[comp[t]] = 1; bgCount++; }
      } else if (cs >= 8 && cs <= n * cfg.islandMax) {
        /* Streifen (z. B. weisse Adidas-Streifen) sind lang und schmal und bleiben erhalten; Saum-Oeffnungen sind eher rundlich */
        var iw = bx1 - bx0 + 1, ih = by1 - by0 + 1;
        var elong = Math.max(iw, ih) / Math.max(1, Math.min(iw, ih));
        if (elong <= 5 && wrapped(comp, cs)) {
          for (var t3 = 0; t3 < cs; t3++) { bg[comp[t3]] = 1; bgCount++; }
        }
      }
    }

    var fgCount = n - bgCount;
    if (fgCount < n * 0.04 || fgCount > n * 0.92) return null;

    /* Randband (2 Pixel) um den Hintergrund: halbtransparente Kante, weisse Saeume werden herausgerechnet */
    var reach = bg.slice();
    var band = new Uint8Array(n);
    for (var round = 0; round < 2; round++) {
      var next = reach.slice();
      for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
          p = y * w + x;
          if (reach[p]) continue;
          if ((x > 0 && reach[p - 1]) || (x < w - 1 && reach[p + 1]) || (y > 0 && reach[p - w]) || (y < h - 1 && reach[p + w])) {
            next[p] = 1;
            band[p] = 1;
          }
        }
      }
      reach = next;
    }

    /* Belichtung: Helligkeitsverteilung des Teils (ohne Rand) messen */
    var hist = new Uint32Array(256);
    var hc = 0;
    var darkN = 0;
    for (i = 0; i < n; i++) {
      if (bg[i] || band[i]) continue;
      o = i * 4;
      var hl = Math.min(255, Math.round(0.299 * px[o] + 0.587 * px[o + 1] + 0.114 * px[o + 2]));
      hist[hl]++;
      hc++;
      var hmx = Math.max(px[o], px[o + 1], px[o + 2]);
      if (hl < 90 && hmx > 0 && (hmx - Math.min(px[o], px[o + 1], px[o + 2])) / hmx < 0.35) darkN++;
    }
    function pct(q) {
      var tgt = hc * q, acc = 0, k;
      for (k = 0; k < 256; k++) { acc += hist[k]; if (acc >= tgt) return k; }
      return 255;
    }
    var p02 = pct(0.02);
    var kk;
    /* Anteil dunkler Pixel: nur Teile mit viel Schwarz/Dunkelgrau bekommen die Schwarz-Korrektur (Tracksuits mit dunkler Hose zaehlen mit) */
    var darkShare = hc ? darkN / hc : 0;
    var dk = cfg.dark * Math.max(0, Math.min(1, (darkShare - 0.12) / 0.25));
    var bp = Math.min(p02, 40) * dk;

    var sx = 0, sy = 0, cnt = 0;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        p = y * w + x;
        o = p * 4;
        var a;
        if (bg[p]) {
          a = 0;
        } else if (band[p]) {
          var m = Math.min(px[o], px[o + 1], px[o + 2]);
          a = Math.max(0, Math.min(1, (250 - m) / 50));
          if (a < 0.12) a = 0;
          if (a > 0) {
            for (c = 0; c < 3; c++) {
              var v = (px[o + c] - 255 * (1 - a)) / a;
              px[o + c] = v < 0 ? 0 : (v > 255 ? 255 : v);
            }
          }
        } else {
          a = 1;
        }
        if (a > 0) {
          var r0 = px[o], g0 = px[o + 1], b0 = px[o + 2];
          var lum = 0.299 * r0 + 0.587 * g0 + 0.114 * b0;
          var mxv = Math.max(r0, g0, b0), mnv = Math.min(r0, g0, b0);
          var sat0 = mxv > 0 ? (mxv - mnv) / mxv : 0;
          /* nur wirklich grelle Neonfarben (fast volle Saettigung und Helligkeit) werden beruhigt */
          var neon = ss(sat0, 0.85, 0.97) * ss(mxv / 255, 0.88, 0.98);
          /* Farben kraeftiger und mehr Kontrast, damit das Teil vom Kachelgruen absticht */
          var satF = cfg.sat * (1 - cfg.neon * neon);
          var cr = [0, 0, 0];
          for (c = 0; c < 3; c++) {
            var cv = lum + (px[o + c] - lum) * satF;
            cv = (cv - 128) * cfg.contrast + 128;
            cr[c] = cv < 0 ? 0 : (cv > 255 ? 255 : cv);
          }
          var lum2 = 0.299 * cr[0] + 0.587 * cr[1] + 0.114 * cr[2];
          var lumT = lum2;
          if (dk > 0 && lum2 > 0) {
            /* dunkle, unbunte Stellen (Schwarz, Dunkelgrau): deutlich tieferes Schwarz; bunte Farben bleiben unberuehrt */
            var m2 = Math.max(cr[0], cr[1], cr[2]), n2 = Math.min(cr[0], cr[1], cr[2]);
            var wd = (1 - ss(lum2, 70, 140)) * (1 - ss(m2 > 0 ? (m2 - n2) / m2 : 0, 0.3, 0.6));
            var tv = Math.max(0, (lum2 - bp) / (255 - bp));
            lumT = lum2 + (255 * Math.pow(tv, 1.3) - lum2) * wd * dk;
          }
          /* Ueberbelichtung (fast weisse Stellen) daempfen */
          if (lumT > cfg.highlight) lumT = cfg.highlight + (lumT - cfg.highlight) * 0.5;
          var mult = (lum2 > 0 ? lumT / lum2 : 1) * (1 - cfg.neonDark * neon);
          for (c = 0; c < 3; c++) {
            var cf = cr[c] * mult;
            px[o + c] = cf < 0 ? 0 : (cf > 255 ? 255 : cf);
          }
        }
        px[o + 3] = Math.round(a * 255);
        if (a > 0.5) { sx += x; sy += y; cnt++; }
      }
    }
    if (cnt < 10) return null;

    /* Keine automatische Drehung: das Teil bleibt so, wie es fotografiert wurde.
       Gerade gestellt wird per Produkt-Tag (kachel-links-N / kachel-rechts-N), siehe unten. */
    var mx = sx / cnt, my = sy / cnt;
    var tiltDeg = 0;
    /* Handdrehung aus dem Produkt-Tag (kachel-links-N / kachel-rechts-N) kommt zusaetzlich */
    var angle = (tiltDeg + (cfg.rot || 0)) * Math.PI / 180;
    var cosA = Math.cos(angle), sinA = Math.sin(angle);
    var minX2 = 1e9, maxX2 = -1e9, minY2 = 1e9, maxY2 = -1e9;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        if (px[(y * w + x) * 4 + 3] <= 128) continue;
        var dx = x - mx, dy = y - my;
        var rx2 = dx * cosA - dy * sinA;
        var ry2 = dx * sinA + dy * cosA;
        if (rx2 < minX2) minX2 = rx2;
        if (rx2 > maxX2) maxX2 = rx2;
        if (ry2 < minY2) minY2 = ry2;
        if (ry2 > maxY2) maxY2 = ry2;
      }
    }
    var bw = (maxX2 - minX2) + 1;
    var bh = (maxY2 - minY2) + 1;
    if (bw < 4 || bh < 4) return null;

    return {
      angle: angle,
      deg: tiltDeg,
      mx: mx,
      my: my,
      cxr: (minX2 + maxX2) / 2,
      cyr: (minY2 + maxY2) / 2,
      bw: bw,
      bh: bh
    };
  }
  /*ANALYZE-END*/

  /* ======================================================================
     Zwischenspeicher im Browser (IndexedDB): fertige Kacheln als kleine JPEGs
     ====================================================================== */
  function readTileColor() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--vbyc-tile');
    return (v && v.trim()) || '#A9C2B0';
  }

  function openDb(cb) {
    var called = false;
    function once() { if (!called) { called = true; cb(); } }
    try {
      if (!window.indexedDB) { once(); return; }
      var req = indexedDB.open('vbyc-tiles', 1);
      req.onupgradeneeded = function () { req.result.createObjectStore('t'); };
      req.onsuccess = function () { db = req.result; once(); };
      req.onerror = function () { db = null; once(); };
      req.onblocked = function () { once(); };
    } catch (e) { db = null; once(); }
  }

  function cacheGet(key, cb) {
    if (!db) { cb(null); return; }
    try {
      var r = db.transaction('t', 'readonly').objectStore('t').get(key);
      r.onsuccess = function () { cb(r.result || null); };
      r.onerror = function () { cb(null); };
    } catch (e) { cb(null); }
  }

  function cachePut(key, value) {
    if (!db) return;
    try { db.transaction('t', 'readwrite').objectStore('t').put(value, key); } catch (e) { /* egal */ }
  }

  /* Handdrehung in Grad (positiv = nach rechts), kommt aus dem Produkt-Tag */
  function rotOf(link) {
    var r = parseFloat(link.getAttribute('data-vbyc-rot'));
    if (!isFinite(r)) return 0;
    return Math.max(-30, Math.min(30, r));
  }

  function cfgFor(job) {
    var c = {};
    for (var k in CFG) c[k] = CFG[k];
    c.rot = job.rot;
    var wv = whiteOf(job.link); if (wv) c.white = wv;
    return c;
  }

  function keyFor(img) {
    var s = img.getAttribute('src') || img.currentSrc || '';
    var base = s.split('?')[0];
    var v = s.match(/[?&]v=(\d+)/);
    return VERSION + '|' + tile + '|' + base + (v ? '|' + v[1] : '');
  }

  /* ======================================================================
     Fotos laden
     ====================================================================== */
  /* Kleinstes Bild aus srcset wählen, das mindestens MIN_WIDTH breit ist (sonst das größte) */
  function bestSource(img) {
    var cands = [];
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (srcset) {
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var wv = parseInt(bits[1], 10) || 0;
        if (bits[0] && wv) cands.push({ url: bits[0], w: wv });
      });
    }
    var src = null;
    if (cands.length) {
      cands.sort(function (a, b) { return a.w - b.w; });
      var pick = null;
      for (var i = 0; i < cands.length; i++) { if (cands[i].w >= MIN_WIDTH) { pick = cands[i]; break; } }
      if (!pick) pick = cands[cands.length - 1];
      src = pick.url;
      if (pick.w >= MIN_WIDTH) return src;
    }
    src = src || img.getAttribute('src') || img.currentSrc;
    if (src && /([?&])width=\d+/.test(src)) src = src.replace(/([?&])width=\d+/, '$1width=' + MIN_WIDTH);
    return src;
  }

  /* Was zuerst? Die Kachel, die dem sichtbaren Bereich am nächsten ist (nach unten bevorzugt) */
  function distance(link) {
    var r = link.getBoundingClientRect();
    return r.top < 0 ? -r.top * 2 : r.top;
  }

  function takeClosest(list, getLink) {
    var best = 0;
    var bestD = 1e12;
    for (var i = 0; i < list.length; i++) {
      var dd = distance(getLink(list[i]));
      if (dd < bestD) { bestD = dd; best = i; }
    }
    return list.splice(best, 1)[0];
  }

  function finish(link, out) {
    if (link._vbycT) { clearTimeout(link._vbycT); link._vbycT = 0; }
    if (link.getAttribute('data-vbyc-tile') === 'done') return;
    if (out) {
      out.className = 'vbyc-tile-canvas';
      out.setAttribute('aria-hidden', 'true');
      link.appendChild(out);
      link.classList.add('vbyc-tile-ready');
      link.setAttribute('data-vbyc-tile', 'done');
    } else {
      link.setAttribute('data-vbyc-tile', 'skip');
    }
  }

  function showCached(link, img, dataUrl, fail) {
    var im = new Image();
    im.onload = function () {
      var c = document.createElement('canvas');
      c.width = im.naturalWidth || SIZE;
      c.height = im.naturalHeight || SIZE;
      c.getContext('2d').drawImage(im, 0, 0);
      finish(link, c);
      /* Originalfoto wird nicht mehr gebraucht: wenn es noch nicht geladen ist, Download abbrechen */
      if (img && !img.complete) {
        img.removeAttribute('srcset');
        img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      }
    };
    im.onerror = fail;
    im.src = dataUrl;
  }

  /* Arbeitsbild vorbereiten */
  function prepare(link, source, key) {
    try {
      var k = Math.min(1, MAX_SOURCE / Math.max(source.naturalWidth, source.naturalHeight));
      var w = Math.max(2, Math.round(source.naturalWidth * k));
      var h = Math.max(2, Math.round(source.naturalHeight * k));
      var work = document.createElement('canvas');
      work.width = w;
      work.height = h;
      var ctx = work.getContext('2d', { willReadFrequently: true });
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(source, 0, 0, w, h);
      ctx.getImageData(0, 0, 1, 1); /* wirft einen Fehler, wenn das Foto ohne CORS geladen wurde */
      return { link: link, key: key, w: w, h: h, work: work, ctx: ctx, rot: rotOf(link) };
    } catch (e) {
      return null;
    }
  }

  /* Zweiter Weg: Foto separat laden (nur wenn das Foto der Seite nicht nutzbar ist) */
  function downloadSeparate(link, img, url, key, next) {
    var source = new Image();
    source.crossOrigin = 'anonymous';
    var triedFallback = false;
    source.onload = function () {
      var job = prepare(link, source, key);
      if (job) { ready.push(job); pump(); } else { finish(link, null); }
      next();
    };
    source.onerror = function () {
      var fallback = img.getAttribute('src') || img.currentSrc;
      if (!triedFallback && fallback && fallback !== url) {
        triedFallback = true;
        source.src = fallback;
        return;
      }
      finish(link, null);
      next();
    };
    source.src = url;
  }

  /* Erster Weg: das Foto, das die Seite ohnehin lädt (img hat crossorigin) – so wird nichts doppelt geladen */
  function download(link, img, url, key, next) {
    if (!img.hasAttribute('crossorigin')) { downloadSeparate(link, img, url, key, next); return; }
    var settled = false;
    function fallback() {
      if (settled) return;
      settled = true;
      downloadSeparate(link, img, url, key, next);
    }
    function use() {
      if (settled) return;
      settled = true;
      if (img.naturalWidth < MIN_WIDTH && url && img.currentSrc !== url) { downloadSeparate(link, img, url, key, next); return; } /* Foto der Seite zu klein: scharfere Version laden */
      var job = prepare(link, img, key);
      if (job) { ready.push(job); pump(); next(); } else { downloadSeparate(link, img, url, key, next); }
    }
    if (img.complete) {
      if (img.naturalWidth > 0) use(); else fallback();
      return;
    }
    img.addEventListener('load', use, { once: true });
    img.addEventListener('error', fallback, { once: true });
    if (img.loading === 'lazy') img.loading = 'eager'; /* jetzt laden, nicht erst beim Scrollen */
  }

  /* Einzelne helle Teile: strengere Hintergrund-Schwelle (Teil der Produktadresse -> Wert; hoeher = nur fast reines Weiss wird entfernt) */
  var WHITE_FOR = { 'cityscape-jacquard-vintage-strickpullover': 252 };
  function whiteOf(link) {
    var href = link.getAttribute('href') || '';
    for (var k in WHITE_FOR) if (href.indexOf(k) > -1) return WHITE_FOR[k];
    return 0;
  }

  function startLoad(link, next) {
    var img = link.querySelector('img');
    var url = img ? bestSource(img) : null;
    if (!url) { link.setAttribute('data-vbyc-tile', 'skip'); next(); return; }
    link.setAttribute('data-vbyc-tile', 'loading');
    link._vbycT = setTimeout(function () {
      if (link.getAttribute('data-vbyc-tile') === 'loading') link.setAttribute('data-vbyc-tile', 'skip');
    }, GIVE_UP_MS);
    var rot = rotOf(link);
    var key = keyFor(img) + (rot ? '|r' + rot : '') + (whiteOf(link) ? '|w' + whiteOf(link) : '');
    cacheGet(key, function (hit) {
      if (hit === 'skip') { finish(link, null); next(); return; }
      if (hit) {
        showCached(link, img, hit, function () { download(link, img, url, key, function () {}); });
        next();
        return;
      }
      download(link, img, url, key, next);
    });
  }

  function pumpLoads() {
    while (activeLoads < MAX_LOADS && loadQueue.length) {
      var link = takeClosest(loadQueue, function (l) { return l; });
      activeLoads++;
      startLoad(link, function () { activeLoads--; pumpLoads(); });
    }
  }

  function enqueue(link) {
    loadQueue.push(link);
    pumpLoads();
  }

  /* ======================================================================
     Berechnung: Hintergrund-Threads (parallel), sonst nacheinander im Hauptthread
     ====================================================================== */
  function makeWorkers() {
    try {
      if (!window.Worker || !window.Blob || !window.URL || !window.ImageData) return;
      var src = 'var analyze = ' + analyze.toString() + ';\n' +
        'self.onmessage = function (e) {\n' +
        '  var d = e.data;\n' +
        '  var px = new Uint8ClampedArray(d.buf);\n' +
        '  var res = null;\n' +
        '  try { res = analyze(px, d.w, d.h, d.cfg); } catch (err) { res = null; }\n' +
        '  self.postMessage({ res: res, buf: px.buffer }, [px.buffer]);\n' +
        '};';
      var url = URL.createObjectURL(new Blob([src], { type: 'application/javascript' }));
      var count = Math.max(1, Math.min(3, (navigator.hardwareConcurrency || 2) - 1));
      for (var i = 0; i < count; i++) {
        var wk = new Worker(url);
        wk.job = null;
        wk.onmessage = (function (self) {
          return function (e) {
            var job = self.job;
            self.job = null;
            if (job) done(job, e.data.res, e.data.buf);
            pump();
          };
        })(wk);
        wk.onerror = function () { dropWorkers(); };
        workers.push(wk);
      }
    } catch (e) {
      dropWorkers();
    }
  }

  function dropWorkers() {
    var list = workers;
    workers = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].job) ready.unshift(list[i].job);
      list[i].job = null;
      try { list[i].terminate(); } catch (e) { /* egal */ }
    }
    pump();
  }

  function pump() {
    var i;
    for (i = 0; i < workers.length && ready.length; i++) {
      if (workers[i].job) continue;
      startOnWorker(workers[i], takeClosest(ready, function (j) { return j.link; }));
    }
    if (!workers.length && !inlineBusy && ready.length) {
      runInline(takeClosest(ready, function (j) { return j.link; }));
    }
  }

  function startOnWorker(wk, job) {
    var image;
    try {
      image = job.ctx.getImageData(0, 0, job.w, job.h);
    } catch (e) {
      done(job, undefined, null);
      return;
    }
    wk.job = job;
    var buf = image.data.buffer;
    try {
      wk.postMessage({ w: job.w, h: job.h, cfg: cfgFor(job), buf: buf }, [buf]);
    } catch (e2) {
      wk.job = null;
      ready.unshift(job);
      dropWorkers();
    }
  }

  function runInline(job) {
    inlineBusy = true;
    setTimeout(function () {
      var res;
      var buf = null;
      try {
        var image = job.ctx.getImageData(0, 0, job.w, job.h);
        res = analyze(image.data, job.w, job.h, cfgFor(job));
        buf = image.data.buffer;
      } catch (e) {
        res = undefined;
      }
      done(job, res, buf);
      inlineBusy = false;
      pump();
    }, 0);
  }

  /* Fertige Kachel zusammensetzen: skalieren, mittig setzen, Schatten */
  function compose(work, r) {
    var tall = r.bh / r.bw > TALL_RATIO;
    var out = document.createElement('canvas');
    out.width = SIZE;
    out.height = SIZE;
    var o2 = out.getContext('2d');
    o2.fillStyle = tile;
    o2.fillRect(0, 0, SIZE, SIZE);
    var fit = SIZE * (tall ? FIT_TALL : FIT_NORMAL);
    var sc = Math.min(fit / r.bw, fit / r.bh, MAX_UPSCALE);
    o2.imageSmoothingEnabled = true;
    o2.imageSmoothingQuality = 'high';

    /* Skalieren und Zentrieren in EINEM Schritt (nur ein Resampling = scharf) */
    function drawPiece() {
      o2.save();
      o2.translate(SIZE / 2, SIZE / 2);
      o2.scale(sc, sc);
      o2.translate(-r.cxr, -r.cyr);
      o2.rotate(r.angle);
      o2.drawImage(work, -r.mx, -r.my);
      o2.restore();
    }
    /* Zwei Schatten: weit und weich + eng an der Kontur */
    var m = String(tile).match(/#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i);
    var rgb = m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : [231, 245, 234];
    var dark = Math.round(rgb[0] * 0.38) + ',' + Math.round(rgb[1] * 0.38) + ',' + Math.round(rgb[2] * 0.38);
    o2.shadowColor = 'rgba(' + dark + ',0.55)';
    o2.shadowBlur = SIZE * 0.042;
    o2.shadowOffsetX = SIZE * 0.004;
    o2.shadowOffsetY = SIZE * 0.017;
    drawPiece();
    o2.shadowColor = 'rgba(' + dark + ',0.45)';
    o2.shadowBlur = SIZE * 0.014;
    o2.shadowOffsetX = SIZE * 0.0015;
    o2.shadowOffsetY = SIZE * 0.006;
    drawPiece();
    return out;
  }

  /* res: Ergebnis der Analyse, null = Foto passt nicht (Original zeigen), undefined = technischer Fehler */
  function done(job, res, buf) {
    var out = null;
    if (res && buf) {
      try {
        job.ctx.putImageData(new ImageData(new Uint8ClampedArray(buf), job.w, job.h), 0, 0);
        out = compose(job.work, res);
      } catch (e) {
        out = null;
      }
    }
    job.work.width = 1;
    job.work.height = 1;
    finish(job.link, out);
    if (out) {
      setTimeout(function () {
        try { cachePut(job.key, out.toDataURL('image/jpeg', JPEG_QUALITY)); } catch (e3) { /* egal */ }
      }, 80);
    } else if (res === null) {
      cachePut(job.key, 'skip');
    }
  }

  /* ======================================================================
     Start
     ====================================================================== */
  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          enqueue(entry.target);
        }
      });
    }, { rootMargin: '1200px 0px' });
  }

  function scan(root) {
    var links = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-vbyc-tile')) continue;
      link.setAttribute('data-vbyc-tile', 'queued');
      if (observer && !link.closest('.featured-products__slide')) observer.observe(link);
      else enqueue(link);
    }
  }

  var started = false;
  function start() {
    if (started) return;
    started = true;
    tile = readTileColor();
    makeWorkers();
    scan();
  }

  function boot() {
    openDb(start);
    setTimeout(start, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) { if (started) scan(event.target); });
})();
